import { useMutation } from 'react-query';
import {
  INextError,
  LoggerInstance,
  cerebroClient,
  getHeadersCerebro,
} from '@vfit/shared/data-access';
import { IAuthorizeResponse } from './cdaAuthorize.models';
import { datadogRum } from '@datadog/browser-rum';

export const cdaAuthorizeService = (
  endpoint = 'onboarding/authorize',
  shareCode?: string,
  state?: string
) => {
  datadogRum.addAction('HTTP Request', {
    type: 'CONSUMER',
    method: 'POST',
    url: endpoint,
    body: {},
    headers: {
      ...(shareCode && { 'share-code': shareCode }),
      ...(state && { state: state }),
    },
  });
  return cerebroClient.post(
    endpoint,
    {},
    {
      headers: {
        ...(shareCode && { 'share-code': shareCode }),
        ...(state && { state: state }),
        ...getHeadersCerebro(),
      },
    }
  ) as Promise<IAuthorizeResponse>;
};

export const useCDAAuthorize = () =>
  useMutation(
    ['authorize'],
    ({
      endpoint,
      shareCode,
      state,
    }: {
      endpoint?: string;
      channel?: string;
      shareCode?: string;
      state?: string;
    }) => cdaAuthorizeService(endpoint, shareCode, state),
    {
      onSuccess: (data: IAuthorizeResponse) => {
        LoggerInstance.info(`SUCCESS authorize: `, data);
        datadogRum.addAction('HTTP Response', {
          type: 'CONSUMER',
          url: 'onbarding/authorize',
          status: '200',
          response: data,
        });
      },
      onError: (error: INextError) => {
        LoggerInstance.error(`ERROR on authorize: `, error);
        datadogRum.addAction('HTTP Error', {
          type: 'CONSUMER',
          url: 'onbarding/authorize',
          status: error?.status,
          statusText: error?.statusText,
          error: error,
        });
      },
    }
  );
